export const SITE_INFO = {
  name: 'BoSteendahl.dk',
  tagline: 'Kropsterapi · Coaching · Hypnoterapi',
  phone: '53 12 82 13',
  phoneRaw: '+4553128213',
  email: 'bs@bosteendahl.dk',
  address: 'Vendersgade 37 kl.',
  city: '7000 Fredericia',
  fullAddress: 'Vendersgade 37 kl., 7000 Fredericia',
  cvr: '39751062',
  mapUrl: 'https://goo.gl/maps/jAdmCsEkXUCP1Vmh9',
  bookingUrl: 'https://system.easypractice.net/book/bosteendahl#choose-service',
  hours: [
    { days: 'Mandag', time: '08.00 - 16.00' },
    { days: 'Tirsdag', time: '08.00 - 17.00' },
    { days: 'Onsdag', time: '10.00 - 18.00' },
    { days: 'Torsdag', time: '10.00 - 18.00' },
    { days: 'Fredag', time: '08.00 - 14.00' },
  ],
  logos: {
    brandTransparent: '/_assets/bo-logo-gennemsigtig.png',
    brandFull: '/_assets/logo-11-dec.png',
    rabLogo: '/_assets/rab-logo-til-hjemmeside-og-mails.jpg',
    totumLogo: '/_assets/blue-orange.png',
  }
}

export const NAVIGATION_ITEMS = [
  { title: 'Forside', path: '/', is_active_nav: true, sort_order: 1 },
  { title: 'Kropsterapi', path: '/kropsterapi', is_core: true, is_active_nav: true, sort_order: 2 },
  { title: 'Coaching', path: '/coaching', is_core: true, is_active_nav: true, sort_order: 3 },
  { title: 'Hypnoterapi', path: '/hypnoterapi', is_core: true, is_active_nav: true, sort_order: 4 },
  { title: 'Forløb', path: '/forloeb', is_active_nav: true, sort_order: 5 },
  { 
    title: 'Om Bo', 
    path: '/om-bo', 
    is_active_nav: true, 
    sort_order: 6,
    children: [
      { title: 'Om Bo Steendahl', path: '/om-bo' },
      { title: 'Mine 9 grundprincipper', path: '/mine-9-grundprincipper' },
      { title: 'Klienthistorie - Sorgen gav slip', path: '/klienthistorie' },
      { title: 'Dokumenter & Uddannelse', path: '/uddannelse' }
    ]
  },
  { title: 'Video & Lyd', path: '/video', is_active_nav: true, sort_order: 7 },
  { title: 'Kontakt', path: '/kontakt', is_active_nav: true, sort_order: 8 },
]

export const SERVICES_DATA = [
  {
    slug: 'kropsterapi',
    title: 'Kropsterapi',
    badge: 'Kerneområde',
    icon: 'fa-solid fa-hands-holding-circle',
    short_description: 'FORANDRING INDEFRA - INDTRYK som ikke imødekommes af et modsvarende UDTRYK, sætter sig som TRYK I KROPPEN. TOTUM Kropsterapi skaber balance i krop, tanker og sind.',
    image: '/_assets/20241001-091341632-ios.png',
    summary: 'Totum kropsterapi arbejder med den dybe sammenhæng mellem krop og psyke. Gennem pulserende massage, guidet åndedræt og tryk på akupressurpunkter frisættes gamle spændinger og traumer.',
    is_core_area: true,
  },
  {
    slug: 'coaching',
    title: 'Coaching',
    badge: 'Kerneområde',
    icon: 'fa-solid fa-compass',
    short_description: 'Mindset Coaching og NLP bygger bro mellem dine følelser, tanker og handlinger. Find ind til dine inderste ressourcer og sæt dit fulde potentiale fri.',
    image: '/_assets/20241001-091341640-ios.png',
    summary: 'Kombinationen af samtale, NLP og kropsterapi skaber et personligt rum, hvor vi synliggør de mønstre og begrænsninger, der holder dig tilbage, og frisætter nye handlemuligheder.',
    is_core_area: true,
  },
  {
    slug: 'hypnoterapi',
    title: 'Hypnoterapi',
    badge: 'Kerneområde',
    icon: 'fa-solid fa-brain',
    short_description: 'Hypnoterapi handler om tillid, tryghed og samarbejde. 95 % af vores adfærd styres af underbevidstheden. Skab vedvarende forandring i det underbevidste sind.',
    image: '/_assets/20241001-091341638-ios.png',
    summary: 'I en behagelig, fokuseret tilstand gives der adgang til underbevidsthedens positive intentioner, så gamle begrænsende vaner, fobier eller traumer kan overskrives med tryghed.',
    is_core_area: true,
  }
]

export const REVIEWS_DATA = [
  {
    author: 'Helle Burmester, Gårslev',
    note: 'Klient efter forløb',
    quote: 'Jeg startede til behandling hos Bo, da han søgte prøve klienter. Læste lidt på nettet om kropsterapi, men vidste ikke helt hvad jeg havde i vente hos ham. Jeg blev meget positivt overrasket. Jeg mødte op med en krop der var stresset og det prægede mit arbejde. Det ændrede Bo på. Jeg fik mere ro i kroppen og fik frigivet noget energi. Min fodvorte gennem flere år forsvandt helt, og en gammel skulder skade blev mere flexibel. Bo er behagelig, rolig og yderst professionel. En man har tillid til. Kan kun varmt anbefale at prøve behandling hos ham.',
  },
  {
    author: 'Susanne Nielsen, Vejle',
    note: 'Mor til Anna (9 år)',
    quote: 'Bo har hjulpet min datter på 9 år i forbindelse med hendes hofteoperation. Når hun i genoptræningsperioden har haft smerter, fordi kroppen skulle i gang igen efter en lang periode i kørestol, har han kunnet løsne op, så hun blev klar til at “arbejde” videre og blive rigtig mobil igen. Bo er sød og sjov - så Anna nyder at få behandling af ham, også selv om der skal masseres lidt ømme punkter. Han får vores varmeste anbefaling.',
  },
  {
    author: 'Else Frederiksen, Børkop',
    note: 'Klient',
    quote: 'Det var en rigtig god oplevelse. Da jeg kom hjem var jeg træt - faldt tidligt i søvn og sov som en sten. Efterfølgende har jeg haft en dejlig lethedsfølelse i kroppen. Absolut værd at anbefale.',
  },
  {
    author: 'Rikke Mortensen, Kolding',
    note: 'Klient efter stress og angst',
    quote: 'Jeg var hos Bo, fordi jeg har været igennem en periode med stress og angst, der har givet mig mange fysiske symptomer - især svimmelhed. Ved første behandling fik Bo virkelig løsnet noget op, som havde været gemt væk i min krop i lang tid. Det var en vild oplevelse, og for første gang i månedsvis, efter utallige andre former for behandling, fik jeg en pause fra svimmelheden. Det var helt fantastisk! Behandlingen ved Bo var starten på min vej til heling.',
  },
  {
    author: 'Nikita Fomsgaard, Fredericia',
    note: 'Klient',
    quote: 'Jeg har i dag været til behandling hos Bo. Det var helt igennem fantastisk! Jeg følte mig tilpas igennem hele behandlingen og allerede halvvejs kunne jeg mærke hvordan min krop fik det bedre. Jeg kan klart anbefale en behandling hos Bo! Bo er utrolig behagelig og professionel og er virkelig dygtig til sit fag.',
  },
  {
    author: 'Marianne Aagaard Sørensen, Kolding',
    note: 'Klient efter første behandling',
    quote: '(Efter første behandling) Jeg har det godt, mærker en anderledes ro, overskud og bedre humør. En velvære, det er svær at beskrive, din behandling har gjort noget godt.',
  },
  {
    author: 'Charlotte Hoé',
    note: 'Klienthistorie: Sorgen gav slip',
    quote: 'Efter bare 6 behandlinger er kroppen blevet mere smidig og energien flyder. Smerterne i hoften er væk, og spændingerne i nakke og skulderne har sluppet deres tag. Et fastlåst traume er blevet forløst. Selvindsigt har skærpet opmærksomheden og givet forståelse for indre ressourcer og kompetencer. Fremtiden ligger forude med nye udfordringer og nye muligheder og nye valg. Jeg har en stor taknemmelighed til dig.',
  }
]

export const GALLERIES_DATA = {
  kropsterapi: [
    { src: '/_assets/20241001-091341632-ios.png', title: 'Behandlingsrummet', caption: 'Rolige, trygge rammer til forløb i kropsterapi' },
    { src: '/_assets/20241001-091341629-ios.png', title: 'Kliniklokalet', caption: 'Behandlerbrik og harmonisk atmosfære' },
    { src: '/_assets/20241001-091341637-ios.png', title: 'Klinikindretning', caption: 'Terapeutiske rammer i Vendersgade 37' },
    { src: '/_assets/20241001-091341640-ios.png', title: 'Nærvær og ro', caption: 'Tid og plads til at mærke kroppen' },
    { src: '/_assets/20241001-091341642-ios.png', title: 'Samtale & briks', caption: 'Helhedsorienteret tilgang til krop og sind' },
  ],
  coaching: [
    { src: '/_assets/20220903-135741.jpg', title: 'Samtale & afklaring', caption: 'Bo Steendahl i samtalerummet' },
    { src: '/_assets/krop-sind-tanke3-serialized1.png', title: 'Krop, sind og tanker', caption: 'Samspillet mellem krop, sind og tanker' },
    { src: '/_assets/20170831-o2q2440.jpg', title: 'Forløbsprocessen', caption: 'Indsigt, accept og nye handlemønstre' },
  ],
  hypnoterapi: [
    { src: '/_assets/20241001-091341638-ios.png', title: 'Behandlerstol og ro', caption: 'Afslappet tilstand med fokus på det underbevidste sind' },
    { src: '/_assets/1711543962553-15f9fabe-7704-4ead-8e4a-b185986203c1-1.jpg', title: 'Certificering', caption: 'Certified Practitioner of Hypnotherapy' },
    { src: '/_assets/krop-sind-tanke3-serialized1.png', title: 'Underbevidsthedens dynamik', caption: '95 % af vores adfærd styres af underbevidstheden' },
  ],
  'om-bo': [
    { src: '/_assets/20170831-o2q9154-2.jpg', title: 'Bo Steendahl', caption: 'Totum Kropsterapeut, Hypnotherapy Practitioner & Mindset Coach' },
    { src: '/_assets/20220705-142422.jpg', title: 'Bo i klinikken', caption: 'Nærværende og professionel behandling i Fredericia' },
    { src: '/_assets/20220903-135741.jpg', title: 'Forandring indefra', caption: 'Hjælper klienter med at genfinde balancen' },
    { src: '/_assets/20170831-o2q2440.jpg', title: 'Bo Steendahl', caption: 'En solid livserfaring og dedikeret håndværk' },
  ],
  klinik: [
    { src: '/_assets/20241001-091341632-ios.png', title: 'Klinikken i Fredericia', caption: 'Vendersgade 37 kl., 7000 Fredericia' },
    { src: '/_assets/20241001-091341638-ios.png', title: 'Behandlingsrum', caption: 'Fokuseret ro og velvære' },
    { src: '/_assets/20220705-142422.jpg', title: 'Velkommen hos Bo', caption: 'En tryg ramme om dit forløb' },
    { src: '/_assets/kortvendersgade37.png', title: 'Beliggenhed', caption: 'Centralt placeret i Fredericia' },
  ]
}

export const VIDEOS_DATA = [
  {
    slug: 'bosteendahldk-profilfilm-24',
    title: 'BoSteendahlDK profilfilm 24',
    description: 'Bo Steendahl - Forandring indefra. Se filmen og hør om tilgangen til kropsterapi, coaching og hypnoterapi.',
    type: 'youtube',
    source: '29PQYHSfCTA',
    poster: 'https://i.ytimg.com/vi/29PQYHSfCTA/hqdefault.jpg'
  },
  {
    slug: 'claus-fortaelling',
    title: "Claus' fortælling: Fra stress til dyb ro",
    description: 'Hør hele Claus\' fortælling om sin vilde forvandling, fra stress, hårtab og indre kaos – til dyb ro, styrke og selvkontrol.',
    type: 'file',
    source: '/_assets/claus-teaser-fb-opslag.mp4',
    poster: '/_assets/20220903-135741.jpg'
  },
  {
    slug: 'hovedpine-trykpunkter',
    title: 'Slip af med din hovedpine',
    description: 'Enkle og effektive trykpunkter fra kropsterapien til lindring af spændingshovedpine.',
    type: 'file',
    source: '/_assets/hovedpine-trykpunkter.mp4',
    poster: '/_assets/20241001-091341638-ios.png'
  }
]
